// import { hubspotAccountConnector, salesforceAccountConnector } from '#/mocks';
import { CKCompanyLogo, CKDrawer, CKLayoutHorizontal } from 'clearkit';
import { some } from 'lodash';
import Helmet from 'react-helmet';

import AttributeBrowser from '~/components/AttributeBrowser';
import GraphqlError from '~/components/GraphqlError';
import wrapError from '~/components/JavascriptError/JavascriptErrorHandler';
import LoadingArea from '~/components/LoadingArea';
import MissingPage from '~/components/MissingPage';
import { useEnrichmentByEncryptedDomainQuery } from '~/generated/graphql';

import CompanyDetails from '../Show/Details';

type CompanyFromEncryptedDomainProps = {
  encryptedDomain: string;
};

const CompanyFromEncryptedDomain = ({
  encryptedDomain,
}: CompanyFromEncryptedDomainProps) => {
  const { data, loading, error, refetch } = useEnrichmentByEncryptedDomainQuery(
    {
      variables: { encryptedDomain },
    },
  );

  if (loading) {
    return <LoadingArea className="x-sidebar" loading />;
  }

  if (!data?.enrichmentData) {
    return <MissingPage className="x-sidebar" />;
  }

  if (error) {
    return (
      <div className="x-sidebar">
        <GraphqlError error={error} refetch={refetch} />;
      </div>
    );
  }

  // Format an object that is expected for CompanyDetails
  const company = {
    ...(data?.enrichmentData || {}),
    ...(data?.enrichmentData?.geo || {}),
    ...(data?.enrichmentData?.metrics || {}),
    ...(data?.enrichmentData?.category || {}),
    linkedin: data?.enrichmentData?.linkedin?.handle || undefined,
    twitter: data?.enrichmentData?.twitter?.handle || undefined,
    facebook: data?.enrichmentData?.facebook?.handle || undefined,
  };

  // TODO: bring back salesforce/hubspot data when using this on visitor report
  // const { salesforceAccounts, hubspotCompanies } = paginateData(company, {
  //   fields: ['salesforceAccounts', 'hubspotCompanies'],
  // });

  return (
    <div className="x-sidebar">
      <Helmet title={company.name as string} />
      <CKDrawer.Header>
        <CKLayoutHorizontal justifyContent="start">
          <CKCompanyLogo
            className="shadow-sm"
            cornerRadius={8}
            domain={company.domain}
            size={56}
          />

          <div>
            <CKDrawer.Heading>
              {company.name || company.domain || 'Loading...'}
            </CKDrawer.Heading>
            <a
              className="text-blue"
              href={`http://${company.domain}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {company.domain || '...'}
            </a>
          </div>
        </CKLayoutHorizontal>
      </CKDrawer.Header>
      <GraphqlError error={error} inline refetch={refetch} />

      <div className="ck-scrollbar ck-scrollbar--vertical">
        <CompanyDetails
          company={company as any}
          hideProspectorPreview
          // hubspotCompanies={hubspotCompanies}
          // hubspotOwners={hubspotAccountConnector?.owners}
          // salesforceAccountConnector={salesforceAccountConnector}
          // salesforceAccounts={salesforceAccounts}
        />
        <LoadingArea loading={!some([data?.enrichmentData])}>
          <AttributeBrowser
            enrichment={data?.enrichmentData}
            object={data?.enrichmentData}
            // hubspotCompanies={hubspotCompanies}
            // hubspotOwners={hubspotAccountConnector?.owners}
            // salesforceAccountConnector={salesforceAccountConnector}
            // salesforceAccounts={salesforceAccounts}
          />
        </LoadingArea>
      </div>
    </div>
  );
};

export default wrapError(CompanyFromEncryptedDomain);
